export default __webpack_public_path__ + "static/media/31.cb1b2b71.jpg";